import React from 'react'
import { Heading2, Space } from '@gousto-internal/citrus-react'
import { Alert } from 'goustouicomponents/dist'
import { useParams } from 'react-router-dom'
import { HeroWithBreadcrumbs } from '../../components/HeroWithBreadcrumbs'
import { useFetchCategories } from '../../hooks/useFetchCategories'
import { useFetchSections } from '../../hooks/useFetchSections'
import { NavigationCategories } from '../../components/NavigationCategories'
import { ContentLoader } from '../../components/ContentLoader'
import { MainColumn, SecondaryColumn, TwoColumns } from '../../layouts/TwoColumns'
import { SectionContent } from '../../components/SectionContent'

type IdInParams = {
  categoryId: string,
  sectionId: string,
}

export const Section = () => {
  const { categoryId: paramCategoryId, sectionId: paramSectionId } = useParams<IdInParams>()

  const {
    categoriesError,
    isCategoriesFetching,
    categories,
  } = useFetchCategories()

  const {
    sectionsError,
    isSectionsFetching,
    sections,
  } = useFetchSections(paramCategoryId)

  const shouldRenderErrorAlert = categoriesError
    || sectionsError
    || (!isCategoriesFetching && !categories)
    || (!isSectionsFetching && !sections)

  const renderFirstColumn = () => {
    if (shouldRenderErrorAlert) {
      return (
        <Alert type="danger">
          <Heading2 size={4}>Something went wrong!</Heading2>
          <p>There is an issue fetching the topics.</p>
        </Alert>
      )
    }

    if (categories) {
      return (
        <NavigationCategories
          categories={categories}
          currentTopicId={paramCategoryId}
          sections={sections || []}
        />
      )
    }

    return <ContentLoader />
  }

  return (
    <>
      <HeroWithBreadcrumbs
        categories={categories}
        currentCategoryId={paramCategoryId}
        sections={sections}
        currentSectionId={paramSectionId}
      />
      <TwoColumns>
        <SecondaryColumn>
          {renderFirstColumn()}
        </SecondaryColumn>
        <MainColumn>
          <Heading2 size={5}>Articles</Heading2>
          <Space size={5} />
          <SectionContent id={paramSectionId} />
        </MainColumn>
      </TwoColumns>
    </>
  )
}
